import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, JSX } from 'react';
import EmailForm from '../../email-form';
import type { HeaderProps } from '../types';
type EmailFormProps = ComponentProps<typeof EmailForm>;
type EmailPageStructureProps = {
  children?: JSX.Element | null;
  defaultEmail?: string;
  Footer?: JSX.Element;
  Header: (props: HeaderProps) => JSX.Element;
  isLoading?: boolean;
  onSubmit: (email: string) => void;
  texts: {
    header: {
      title: string;
      subtitle?: string;
    };
  } & EmailFormProps['texts'];
};
const EmailPageStructure = t0 => {
  const $ = _c(19);
  const {
    children,
    defaultEmail,
    Footer,
    Header,
    isLoading,
    onSubmit,
    texts
  } = t0;
  let formTexts;
  let t1;
  if ($[0] !== texts) {
    ({
      header: t1,
      ...formTexts
    } = texts);
    $[0] = texts;
    $[1] = formTexts;
    $[2] = t1;
  } else {
    formTexts = $[1];
    t1 = $[2];
  }
  const {
    title,
    subtitle
  } = t1;
  let t2;
  if ($[3] !== onSubmit) {
    t2 = formData => {
      onSubmit(formData.email);
    };
    $[3] = onSubmit;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleFormSubmit = t2;
  let t3;
  if ($[5] !== Header || $[6] !== subtitle || $[7] !== title) {
    t3 = <Header title={title} subtitle={subtitle} />;
    $[5] = Header;
    $[6] = subtitle;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== defaultEmail || $[10] !== formTexts || $[11] !== handleFormSubmit || $[12] !== isLoading) {
    t4 = <EmailForm defaultEmail={defaultEmail} isLoading={isLoading} onSubmit={handleFormSubmit} texts={formTexts} />;
    $[9] = defaultEmail;
    $[10] = formTexts;
    $[11] = handleFormSubmit;
    $[12] = isLoading;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== Footer || $[15] !== children || $[16] !== t3 || $[17] !== t4) {
    t5 = <>{t3}{t4}{Footer}{children}</>;
    $[14] = Footer;
    $[15] = children;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default EmailPageStructure;